import React, { Suspense, lazy } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';

import { isTokenValid } from '../../../util/user';
import RouteLoading from './RouteLoading';
import UnauthorizedRoutes from './UnauthorizedRoutes';
import AuthorizedRoutes from './AuthorizedRoutes';
import { page } from '../../../util/analytics/segment';

const PublicTrackingRunPage = lazy(() =>
	import(
		/* webpackChunkName: "PublicTrackingRun" */ '../pages/Tracking/PublicTrackingRunPage'
	)
);

const AuthSwitch = () => {
	if (isTokenValid()) {
		return <AuthorizedRoutes />;
	}
	return <UnauthorizedRoutes />;
};

const RouteAutorizer = () => {
	page();
	// The public share route is matched before the auth split so it renders the
	// same isolated, sidebar-free run view whether or not the viewer is logged
	// in — external recipients have no session, and an internal user opening the
	// link should still land on the shared page, not the full app shell.
	return (
		<Switch>
			<Route
				path="/Tracking/share/:token"
				render={props => (
					<Suspense fallback={<RouteLoading />}>
						<PublicTrackingRunPage {...props} />
					</Suspense>
				)}
			/>
			<Route render={() => <AuthSwitch />} />
		</Switch>
	);
};

const MainRouter = () => {
	return <RouteAutorizer />;
};

export default connect()(MainRouter);
